// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".SelectListDialog-content__lZr_K{display:flex;flex-direction:column;height:100%;max-height:100%;overflow:hidden}.SelectListDialog-body__NpSK8{display:flex;flex:1;flex-direction:column;min-height:0;padding:0;overflow:hidden}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": "SelectListDialog-content__lZr_K",
	"body": "SelectListDialog-body__NpSK8"
};
export default ___CSS_LOADER_EXPORT___;
